import {
  Alert,
  CardActions,
  CardContent,
  TextField,
  styled,
} from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { passwordResetMail } from "../api/auth";

const CustomTextField = styled(TextField)(({ theme }) => ({
  width: "100%",
  height: "56px",
}));

export default function PasswordResetMail(props) {
  const [isSuccess, setIsSuccess] = useState(false);
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm();

  const onsubmit = (data) => {
    passwordResetMail(data).then(
      (success) => {
        setIsSuccess(true);
      },
      (error) => {
        setError("root.serverError", {
          type: "server",
          message: "メールの送信に失敗しました",
        });
      },
    );
  };
  const onerror = (err) => console.log(err);

  return isSuccess ? (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        maxWidth: 500,
        margin: "0 auto",
      }}
    >
      <Container
        maxWidth="sm"
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          padding: "0px",
          width: "552px",
          maxWidth: "90vw",
          height: "380px",
          backgroundColor: "common.white.main",
        }}
      >
        <Typography
          variant="h5"
          sx={{ mb: 3, textAlign: "center", width: "100%" }}
        >
          メール送信完了
        </Typography>
        <Alert severity="success" sx={{ mb: 3, width: "100%" }}>
          パスワードリセット用のメールを送信しました。
        </Alert>
        <Typography variant="body1" sx={{ mb: 2, textAlign: "start" }}>
          メールの指示に従ってパスワードの再設定を行ってください。
        </Typography>
        <Typography variant="body2" sx={{ mb: 2, textAlign: "start" }}>
          ※メールが届かない場合は、迷惑メールフォルダをご確認ください。
        </Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            navigate("/login");
          }}
          sx={{ mt: 2 }}
        >
          ログイン画面に戻る
        </Button>
      </Container>
    </Box>
  ) : (
    <Box
      component="form"
      onSubmit={handleSubmit(onsubmit, onerror)}
      noValidate
      sx={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        flexFlow: "column",
        alignItems: "center",
      }}
    >
      <Container
        maxWidth="sm"
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          padding: "0px",
          width: "552px",
          maxWidth: "90vw",
          height: "380px",
          backgroundColor: "common.white.main",
        }}
      >
        <CardContent
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            padding: "16px",
            gap: "16px",
            width: "100%",
            height: "500px",
          }}
        >
          <Typography variant="h5" component="h1" sx={{ mb: 3 }}>
            パスワードの再設定
          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
            ご登録のメールアドレスを入力してください。
            <br />
            パスワード再設定用のリンクをメールでお送りします。
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              marginBottom: "16px",
              gap: "24px",
              width: "100%",
              height: "50px",
            }}
          >
            <CustomTextField
              id="mail"
              label="メールアドレス"
              variant="outlined"
              size="medium"
              type="email"
              {...register("mail", {
                required: "メールは必須です",
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                  message: "有効なメールアドレスを入力してください",
                },
              })}
              error={"mail" in errors}
              helperText={errors.mail?.message}
            />
          </Box>
          <Button
            variant="contained"
            type="submit"
            color="primary"
            size="large"
            onClick={() => onsubmit}
            sx={{
              alignItems: "center",
              padding: "8px 22px",
              width: "100%",
              height: "42px",
              marginTop: "10px",
            }}
          >
            再設定リンクを送信
          </Button>
          {errors.root?.serverError && (
            <Typography
              variant="body2"
              sx={{
                color: "error.main",
                margin: "-10px 15,0,0",
                width: "100%",
                textAlign: "center",
              }}
            >
              {errors.root.serverError?.message}
            </Typography>
          )}
        </CardContent>
      </Container>
      <CardActions
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "flex-start",
          padding: "0px",
          gap: "8px",
          width: "552px",
          maxWidth: "90vw",
          height: "20px",
        }}
      >
        <Link
          href="/login"
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            padding: "0px",
            width: "184px",
            height: "20px",
            marginTop: "10px",
          }}
        >
          <Typography variant="body2">ログイン画面に戻る</Typography>
        </Link>
      </CardActions>

      <Box textAlign="center" />
    </Box>
  );
}
